.accordion-container {
  border: 1px solid var(--color-gray-light);
  border-radius: 8px;
  s-accordion-stacked {
    > details {
      * {
        box-sizing: border-box;
      }
    }
    &:first-of-type summary {
      border: 0;
      &:focus-visible {
        border-radius: 8px 8px 0 0;
      }
    }
    details[open] {
      &:last-of-type summary {
        border-radius: 0;
      }
    }
    &:last-of-type summary {
      border-radius: 0 0 8px 8px;
    }

    details {
      inline-size: 100%;
      * {
        box-sizing: border-box;
      }
      &[open] {
        > *:not(summary) {
          padding-block-end: var(--margin-sm);
          padding-inline: var(--padding-sm);
        }
      }
      summary {
        align-items: center;
        border-block-start: 1px solid var(--color-gray-light);
        color: var(--color-gray-darker);
        cursor: pointer;
        display: flex;
        flex-direction: column;
        font-size: var(--font-size-sm);
        justify-content: space-between;
        list-style-type: none;
        padding-block: var(--padding-sm);
        padding-inline: var(--padding-sm);
        .accordion-stacked-header-wrapper {
          align-items: center;
          display: flex;
          inline-size: 100%;
          justify-content: space-between;
          .accordion-stacked-header {
            align-items: flex-start;
            display: flex;
            inline-size: 100%;
            justify-content: space-between;
            padding-inline-end: var(--padding-sm);
            [slot='title'] {
              flex: 1;
              margin: 0;
              max-inline-size: fit-content;
              overflow: auto;
              white-space: wrap;
            }
            [slot='title-accessory'] {
              margin-inline-start: var(--margin-xs);
              &:not(s-tag) {
                margin-block-start: var(--margin-xs);
              }
            }
          }
        }

        [slot='sub-heading'] {
          inline-size: 100%;
          padding-inline-end: var(--padding-sm);
        }

        &:hover {
          s-icon.i-expand-collapse {
            color: var(--color-orange-darker);
          }
        }

        s-icon.i-expand-collapse {
          align-self: baseline;
          color: var(--color-orange-dark);
          line-height: 2rem;
          margin-inline-end: var(--margin-xs);
        }

        &::-webkit-details-marker {
          display: none;
        }

        // Hide focus state on mouse click.
        &:focus:not(:focus-visible) {
          box-shadow: none;
          outline: none;
        }

        // Show focus styles on keyboard focus.
        &:focus-visible {
          border-color: var(--color-blue-dark);
          z-index: 10;
        }
      }
    }
  }
}
